import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';

import { useJiraContext } from 'src/services/jira';

import jira from 'src/lib/api/jira';

const Context = createContext(null);

export const Provider = ({ children }) => {
  const { context: { issueKey } = {} } = useJiraContext();
  const [hasConsumers, setHasConsumers] = useState(false);
  const [value, setValue] = useState([undefined, true, null]);

  useLayoutEffect(() => {
    if (issueKey && hasConsumers) {
      jira
        .getIssue(issueKey)
        .then(issue => setValue([issue, false, null]))
        .catch(error => setValue([undefined, false, error]));
    }
  }, [hasConsumers, issueKey]);

  const contextValue = useMemo(() => [value, setHasConsumers], [value, setHasConsumers]);

  return (
    <Context.Provider value={contextValue}>
      {children}
    </Context.Provider>
  );
};

export const useCurrentIssue = () => {
  const [value, setHasConsumers] = useContext(Context);

  useLayoutEffect(() => {
    setHasConsumers(true);
  }, [setHasConsumers]);

  return value;
};
